import React, { useState, useEffect } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import { Link, NavLink, Redirect } from "react-router-dom";
import productService from "../services/product";
import { swalError } from '../utils/swal';
import ProductBox from "./ProductBox";
import constants from "../utils/constants";
import Searchbar from "./Searchbar";

function Wishlist({ session, setKey, ...props }) {
	const [redirectTo, setRedirectTo] = useState(null);
	const [rows, setRows] = useState([]);
	const [keyword, setKeyword] = useState("");

	useEffect(() => {
		reload();
	}, [keyword]);

	const reload = () => {
		productService.getWishlist(session.token, keyword)
			.then(result => {
				if (result.error) {
					swalError(result.error);
					return;
				}
				setRows(result.data);
			});
	}

	const renderProducts = () => {
		if (!rows || rows.length === 0)
			return (<div>No data found.</div>);

		return rows.map(k => <ProductBox key={k._id} data={k} />)
	}


	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			<div className="container">
				<div className="row mt-20">
					<div className="col">
                    	<p className="cart-title">My Wishlist</p>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<Searchbar keyword={keyword} onChange={setKeyword} bordered={false} />
					</div>
				</div>
				<div className="row products mt-20">
					<div className="col">
						{renderProducts()}
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Wishlist);
